import { postDataService } from '../services/back-end-service'
import { url } from '../services/path-url'
import { onError } from './CommonMethods'
import { getLocalStorage, setLocalStorage } from './localStorage'

export const savedConfig = async (callBack) => {
  try {
    const defaultOrderMenu = getLocalStorage('preference')
    const parsedData = defaultOrderMenu ? JSON.parse(defaultOrderMenu) : null

    await postDataService(
      parsedData,
      url.auth.saveConfigColumn,
      () => {},
      onError
    )
  } finally {
    callBack()
  }
}

export const initConfigStatus = () => {
  setLocalStorage('configColumn', 'true')
}

export const updateOrderColumnKey = (datas, key, column) => {
  try {
    const isExist = datas?.find((it) => it.key === key)
    if (isExist) {
      return datas?.map((it) => {
        if (it.key === key) {
          return {
            ...it,
            column,
          }
        }
        return it
      })
    }
    datas.push({
      key,
      column,
    })
    return datas
  } catch (error) {
    console.log('error in update order', error)
  }
}

export const handleOrder = (
  column,
  path,
  tableName,
  setOrderColumn,
  setIsExistConf
) => {
  try {
    setOrderColumn(column)
    const defaultCached = getLocalStorage('preference')
    if (defaultCached) {
      const parsedData = JSON.parse(defaultCached) || []
      const selectedOrder = parsedData?.find((it) => it.url === path)
      if (selectedOrder) {
        const tempOrder = parsedData.map((it) => {
          if (it.url === path) {
            return {
              ...it,
              url: path,
              orderColumn: tableName
                ? updateOrderColumnKey(it?.orderColumn || [], tableName, column)
                : [{ key: 'tableName', column }],
            }
          }
          return it
        })
        setLocalStorage('preference', JSON.stringify(tempOrder))
        setIsExistConf(true)
        initConfigStatus()
        return
      }
      const tempOrdered = [
        ...parsedData,
        {
          url: path,
          orderColumn: [{ key: tableName || 'tableName', column }],
        },
      ]
      setLocalStorage('preference', JSON.stringify(tempOrdered))
      setIsExistConf(true)
      initConfigStatus()
      return
    }
    setLocalStorage(
      'preference',
      JSON.stringify([
        {
          url: path,
          orderColumn: [{ key: tableName || 'tableName', column }],
        },
      ])
    )
    setIsExistConf(true)
    initConfigStatus()
  } catch (error) {
    console.log('error in handleOrderColumn', error)
  }
}

export const initOrderColumn = (columns, path, tableName, setOrderColumn) => {
  const defaultCached = getLocalStorage('preference')
  const parsedData = defaultCached ? JSON.parse(defaultCached) : null

  if (columns && columns?.length > 0) {
    const defaultOrderedColumn = columns?.map((it) => it.name)

    if (parsedData) {
      const selectedOrder = parsedData?.find((it) => it.url === path)
      const isHaveColumn =
        selectedOrder?.orderColumn && selectedOrder?.orderColumn?.length > 0
      if (isHaveColumn) {
        let columnSelected
        if (tableName) {
          columnSelected = selectedOrder.orderColumn?.find(
            (id) => id.key === tableName
          ) || { key: tableName, column: defaultOrderedColumn }
        } else {
          columnSelected = selectedOrder.orderColumn?.[0] || {
            column: defaultOrderedColumn,
          }
        }
        const setArrayListe = [
          ...columnSelected.column,
          ...defaultOrderedColumn,
        ]
        const uniquedArray = new Set(setArrayListe)
        const tableauUnique = Array.from(uniquedArray)
        setOrderColumn(tableauUnique)
        return
      }
      setOrderColumn(defaultOrderedColumn)
      return
    }
    setOrderColumn(defaultOrderedColumn)
  }
}

